import { Map } from 'immutable';
/**
 * checkoutState state
 *
 * @export
 * @class checkoutState
 */
var SearchState = /** @class */ (function () {
    function SearchState() {
        /**
         * The list of user posts
         *
         * @type {*}
         * @memberof SearchState
         */
        this.Search = Map({});
        this.ActiveSearch = false;
        this.ResArr = Map({});
        this.Mens = Map({});
        this.Women = Map({});
    }
    return SearchState;
}());
export { SearchState };



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/search/searchState.ts
// module id = 589
// module chunks = 50